import AllUsers from "./components/AllUsers";

function Users() {
  return (
    <>
      <AllUsers />
    </>
  );
}

export default Users;
